import { ImmigrationPage as API } from '@src/api/types';
import { ImmigrationPage as Data } from '@src/types';

import generateMedia from './media';

const Factory = (api: API, order: number): Data => ({
  id: api.id,
  audio: api.audio ? generateMedia(api.audio) : undefined,
  containedEntities: api.containedEntities,
  text: api.text,
  topic: api.topic,
  order,
});

export default Factory;
